import './survey_item_chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.ChoiceItemChartView extends Monitoring.Views.Charts.SurveyItemChartView
  id: 'choice-item-chart'
  className: 'processing item'
  template: JST['backbone/templates/monitoring/charts/generic_chart']

  events:
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'
    'click #sort-survey-bars a': 'onClickSortingSelect'

  initialize: (@options = {}) ->
    @facets = @options.facets
    @_settings = @options.settings
    @title = @_settings.name
    @terms = @_itemTerms(@facets.cem_surveys[0], @_settings.code)
    @defaultOrderedTerms = @terms
    @sortingActionsView = new Monitoring.Views.Charts.SortingActionsView()

  render: ->
    @$el.html @template
      title: @title
    @renderSortingActions()
    @trigger('masonry')
    @

  onClickSortingSelect: (event) ->
    @$el.addClass('processing').html('')
    @selectedOptionValue = $(event.target).data('class')
    @sortingActionsView.changeSelectedSorting(@selectedOptionValue)
    if @selectedOptionValue == 'sort_alphabetically_asc'
      @_sortAlphabeticallyAsc()
    else if @selectedOptionValue == 'sort_alphabetically_desc'
      @_sortAlphabeticallyDesc()
    else if @selectedOptionValue == 'sort_percentage_asc'
      @_sortPercentageAsc()
    else if @selectedOptionValue == 'sort_percentage_desc'
      @_sortPercentageDesc()
    else if @selectedOptionValue == 'sort_default'
      @_sortDefault()
    @render()
    @afterAppend()
    @addNoteBox()

  renderSortingActions: ->
    @$('.sorting-actions').html(@sortingActionsView.render().el)

  _sortAlphabeticallyAsc: ->
    @terms = _.sortBy(@defaultOrderedTerms, 'term')

  _sortAlphabeticallyDesc: ->
    @terms = _.sortBy(@defaultOrderedTerms, 'term').reverse()

  _sortPercentageAsc: ->
    @terms = _.sortBy(@defaultOrderedTerms, 'count').reverse()

  _sortPercentageDesc: ->
    @terms = _.sortBy(@defaultOrderedTerms, 'count')

  _sortDefault: ->
    @terms = @defaultOrderedTerms

  afterAppend: ->
    @$el.removeClass('processing')
    data = @parseData()
    @$el.find('.chart').append(new Monitoring.Views.Charts.HorizontalBarChartView({data: data}).render().el)

  parseData: ->
    data = []
    _.each(@terms, (term) ->
      data.push {name: term.term, y: parseInt(term.count), color: '#1289a7'}
    )
    data
